"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatControlPropertyBeforeModify_1 = __importDefault(require("../../shared/formatControlPropertyBeforeModify"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const setObjectPropByPath_1 = __importDefault(require("../../shared/setObjectPropByPath"));
const evaluatePropsToModify = async ({ asyncControlUpdates, propsToModify, evaluateEntryVar, initialControl, }) => {
    let controlToModify = initialControl;
    await Promise.all(Object.entries(propsToModify).map(async ([propName, propEntryVar]) => {
        const formatedProp = propName.replace(/\|/g, '.');
        const propPath = formatedProp.split('.');
        if (propEntryVar.source === 'computeFunction') {
            if (!propEntryVar.executeAfterRender) {
                const evaluatedValue = await evaluateEntryVar(propEntryVar);
                const formatedValue = (0, formatControlPropertyBeforeModify_1.default)({
                    value: evaluatedValue,
                    controlToModify: initialControl,
                    propertyToModify: propPath.join('.'),
                });
                const propHasNotChange = (0, getValueByPathFromUnknown_1.default)(controlToModify, propPath) === formatedValue;
                if (!propHasNotChange) {
                    controlToModify = (0, setObjectPropByPath_1.default)(controlToModify, propPath, formatedValue);
                }
                return;
            }
            asyncControlUpdates.push({
                promiseValueComputer: async () => {
                    const evaluatedValue = evaluateEntryVar(propEntryVar);
                    return (0, formatControlPropertyBeforeModify_1.default)({
                        value: evaluatedValue,
                        controlToModify: initialControl,
                        propertyToModify: propPath.join('.'),
                    });
                },
                controlId: controlToModify.id,
                propPath,
            });
        }
        else {
            const evaluatedValue = await evaluateEntryVar(propEntryVar);
            const formatedValue = (0, formatControlPropertyBeforeModify_1.default)({
                value: evaluatedValue,
                controlToModify: initialControl,
                propertyToModify: propPath.join('.'),
            });
            const propHasNotChange = (0, getValueByPathFromUnknown_1.default)(controlToModify, propPath) === formatedValue;
            if (!propHasNotChange) {
                controlToModify = (0, setObjectPropByPath_1.default)(controlToModify, propPath, formatedValue);
            }
        }
    }));
    return controlToModify;
};
exports.default = evaluatePropsToModify;
